import { AxiosError } from "axios";
import { BE_BASE_URL, BE_RESERVATION_ENDPOINT } from "../../utils/config";
import { ReservedCourse } from "../../types";
import { axiosInstance } from "../../provider/authProvider";
import { goToPage } from "../../utils/utils";

export async function reserveCourseDate(
  variationId: number,
  participants: string[]
) {
  try {
    const axiosResponse = await axiosInstance.post(
      BE_BASE_URL + BE_RESERVATION_ENDPOINT + "date",
      {
        variationId: variationId,
        participants: participants,
      }
    );
    return { status: axiosResponse.status, success: true };
  } catch (e: unknown) {
    const err = e as AxiosError;
    let errorMessage =
      "Si è verificato un errore durante la prenotazione del corso.";

    // Extract error message from response if available
    if (err.response && err.response.data) {
      const responseData = err.response.data as any;
      if (responseData.message) {
        errorMessage = responseData.message;
      } else if (typeof responseData === "string") {
        errorMessage = responseData;
      }
    }

    return {
      status: err.response?.status || 500,
      success: false,
      message: errorMessage,
    };
  }
}

export function getReserveCourseDateByCompanyId(variationId: number) {
  try {
    const axiosResponse = axiosInstance.get<Set<string>>(
      BE_BASE_URL + BE_RESERVATION_ENDPOINT + "getParticipantsByCompanyAndDate",
      {
        params: {
          variationId: variationId,
        },
      }
    );
    return axiosResponse.then((response) => response.data);
  } catch (e: unknown) {
    const err = e as AxiosError;
    //console.log("generic error", err);
    goToPage("500");
  }
}

export function getParticipantsByCompanyAndDate(variationId: number) {
  try {
    const axiosResponse = axiosInstance.get<Set<string>>(
      BE_BASE_URL + BE_RESERVATION_ENDPOINT + "getParticipantsByCompanyAndDate",
      {
        params: {
          variationId: variationId,
        },
      }
    );
    return axiosResponse.then((response) => response.data);
  } catch (e: unknown) {
    const err = e as AxiosError;
    //console.log("generic error", err);
    goToPage("500");
  }
}

export function getAllReserveCourseDateByCompanyId() {
  try {
    const axiosResponse = axiosInstance.get<ReservedCourse[]>(
      BE_BASE_URL + BE_RESERVATION_ENDPOINT + "getAllByCompany"
    );
    return axiosResponse.then((response) => {
      return response.data;
    });
  } catch (e: unknown) {
    const err = e as AxiosError;
    //console.log("generic error", err);
    goToPage("500");
  }
}
